// src/contexts/notificationContext.js (nuevo archivo con el contexto)
import { createContext } from 'react';

const NotificationContext = createContext();

export default NotificationContext;